import { Box, Menu as MuiMenu } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const CustomLabelDropdownWrapper = styled(Box)<{ menuOpen: boolean }>`
  .custom-label-dropdown-menu-button {
    svg {
      width: 20px;
      height: 20px;
      color: ${({ menuOpen }) => (menuOpen ? theme.colors.cta : theme.colors.menuItemText)};
    }
  }
`

export const Menu = styled(MuiMenu)`
  & .MuiPaper-root {
    background-color: ${theme.colors.menuBg};
    box-shadow: 0 4px 8px 0 rgba(30, 26, 29, 0.5);
    border-radius: 12px;
    min-width: 120px;
    margin-top: 4px;
  }

  .MuiList-root {
    padding: 0;

    .MuiMenuItem-root {
      color: ${theme.colors.menuItemText};
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;

      &:first-of-type {
        padding: 16px 0 8px 16px;
      }

      &:last-of-type {
        padding: 8px 0 16px 16px;
      }

      &:hover {
        background-color: ${theme.colors.calendarActionHover};
      }
    }
  }
`
